
const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'https://api.trikcrm.com';
const appConfig = {
    apiPrefix: `${backendBaseUrl}/api/v1/`,
    authenticatedEntryPath: '/apps/home/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: false
}

export default appConfig
